import { networkCall } from "../../../../../util/network-call/network-call";

export const InstructorUserListLoader = async () => {

    const response = await networkCall('/users');

    return response ? response : null;

};